export default __webpack_public_path__ + "b5d2791d699b9fa667cb06bd59f8285c.png";